<div class="m184-page">

  <!-- Cabecera -->
  <div class="m184-header">
    <div class="m184-header__icon"><mat-icon>assignment</mat-icon></div>
    <div>
      <h1 class="m184-header__title">Modelo 184</h1>
      <p class="m184-header__sub">{{ title }}</p>
    </div>
  </div>

  <!-- Acciones -->
  <div class="m184-actions">
    <button mat-stroked-button class="m184-btn" (click)="getData()">
      <mat-icon>refresh</mat-icon> Calcular / Actualizar
    </button>
    <button mat-stroked-button class="m184-btn" (click)="getFile()">
      <mat-icon>file_download</mat-icon> Descargar fichero
    </button>
    <button mat-stroked-button class="m184-btn" (click)="validate()">
      <mat-icon>check</mat-icon> Validar datos
    </button>
    <button mat-stroked-button class="m184-btn" (click)="redirectFileTax()">
      <mat-icon>send</mat-icon> Presentar impuesto
    </button>
  </div>

  <!-- Alertas de validación -->
  <div class="m184-alerts" *ngIf="validations && validations.length > 0">
    <div class="m184-alert" *ngFor="let item of validations; trackBy: trackByIndex">
      <span class="m184-alert__text">{{ item.message }}</span>
      <button class="m184-alert__link" *ngIf="item.key" (click)="scrollToElement(item.key)">Ir al campo</button>
    </div>
  </div>

  <mat-tab-group animationDuration="0ms">
    <mat-tab label="Declarante y resumen de la declaración">

      <div class="m184-card" style="margin-top:16px">
        <div class="m184-card__head">
          <mat-icon>perm_identity</mat-icon>
          <span class="m184-card__head-label">Entidad</span>
        </div>
        <div class="m184-card__body">
          <span class="m184-subhead">Datos identificativos de la entidad</span>
          <div class="m184-fields">
            <app-input inputType="text" placeholder="NIF" name="entNif" [(ngModel)]="data"></app-input>
            <app-input inputType="text" placeholder="Denominación o razón social" name="entRazonSocial" [(ngModel)]="data"></app-input>
            <app-input inputType="text" placeholder="Ejercicio" name="entEjercicio" [(ngModel)]="data"></app-input>
          </div>

          <span class="m184-subhead" style="margin-top:16px">Persona con quíen relacionarse</span>
          <div class="m184-fields">
            <app-input inputType="text" placeholder="Teléfono" name="contactoTelefono" [(ngModel)]="data"></app-input>
            <div style="flex:2 1 320px">
              <app-input inputType="text" placeholder="Apellidos y nombre de la persona con quien relacionarse" name="contactoNombre" [(ngModel)]="data"></app-input>
            </div>
          </div>
        </div>
      </div>

      <div class="m184-card" style="margin-top:16px">
        <div class="m184-card__head">
          <mat-icon>description</mat-icon>
          <span class="m184-card__head-label">Datos adicionales de la entidad</span>
        </div>
        <div class="m184-card__body">
          <span class="m184-subhead">Datos entidad</span>

          <p class="m184-field-label">A) Entidades en régimen atribución de rentas constituidas en España</p>
          <div class="m184-fields">
            <div>
              <span class="m184-field-label">Tipo entidad</span>
              <app-select name="tipoEntidadA" [(ngModel)]="data"
                [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
            </div>
            <div>
              <span class="m184-field-label">Actividad Principal</span>
              <app-select name="actividadPrincipalA" [(ngModel)]="data"
                [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
            </div>
          </div>

          <p class="m184-field-label" style="margin-top:12px">B) Entidades en régimen atribución de rentas constituidas en el extranjero</p>
          <div class="m184-fields">
            <div>
              <span class="m184-field-label">Tipo entidad</span>
              <app-select name="tipoEntidadB" [(ngModel)]="data"
                [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
            </div>
            <div>
              <span class="m184-field-label">Objeto</span>
              <app-select name="objetoB" [(ngModel)]="data"
                [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
            </div>
            <div>
              <span class="m184-field-label">País/Terr</span>
              <app-select name="paisTerrB" [(ngModel)]="data"
                [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
            </div>
            <app-input inputType="text" placeholder="Porcentaje de renta atribuible a miemros resisdentes" name="porcentajeRentaAtribuibleB" [(ngModel)]="data"></app-input>
          </div>

          <p class="m184-field-label" style="margin-top:12px">C) Tributación en Régimen del Impuesto sobre Sociedades</p>
          <div class="m184-check-row">
            <mat-checkbox name="tributacionIsC" [(ngModel)]="data"></mat-checkbox>
          </div>

          <p class="m184-field-label" style="margin-top:4px">D) Importe neto de la cifra de negocios</p>
          <div class="m184-fields">
            <div style="flex:0 0 220px">
              <app-input inputType="text" placeholder="Importe" name="importeCifraNegociosD" [(ngModel)]="data"></app-input>
            </div>
          </div>

          <span class="m184-subhead" style="margin-top:16px">Datos del representante</span>
          <div class="m184-fields">
            <div style="flex:0 0 200px">
              <app-input inputType="text" placeholder="NIF" name="repNif" [(ngModel)]="data"></app-input>
            </div>
            <div style="flex:2 1 320px">
              <app-input inputType="text" placeholder="Apellidos y nombre o razón social" name="repRazonSocial" [(ngModel)]="data"></app-input>
            </div>
          </div>

          <span class="m184-subhead" style="margin-top:16px">Resumen de los datos incluidos en la declaración</span>
          <div class="m184-fields">
            <app-input inputType="text" placeholder="Resumen" name="resumenDatos" [(ngModel)]="data"></app-input>
            <app-input inputType="text" placeholder="Registros" name="resumenRegistros" [(ngModel)]="data"></app-input>
          </div>
        </div>
      </div>

    </mat-tab>

    <mat-tab label="Rentas">
      <div class="m184-card" style="margin-top:16px">
        <div class="m184-card__head">
          <mat-icon>list</mat-icon>
          <span class="m184-card__head-label">Relación de rentas</span>
        </div>
        <div class="m184-card__body">
          <div class="m184-actions" style="margin-bottom:12px">
            <button mat-stroked-button class="m184-btn" (click)="openModal(modelRenta)">
              <mat-icon>add</mat-icon> Añadir
            </button>
          </div>
          <div class="m184-table-wrap">
            <table class="m184-table">
              <thead>
                <tr>
                  <th>Orden</th>
                  <th>Estado</th>
                  <th>Presentado el</th>
                  <th>Clave</th>
                  <th>Subclave</th>
                  <th>País</th>
                  <th>Porcentaje de reduccción</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>orden</td>
                  <td>estado</td>
                  <td>presentado</td>
                  <td>clave</td>
                  <td>sub</td>
                  <td>pais</td>
                  <td>porcent</td>
                  <td>
                    <div class="m184-row-actions">
                      <button mat-stroked-button class="m184-btn" (click)="openModal(modelRenta)">
                        <mat-icon>edit</mat-icon> Editar
                      </button>
                      <button mat-stroked-button class="m184-btn">
                        <mat-icon>delete</mat-icon> Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </mat-tab>

    <mat-tab label="Socios">
      <div class="m184-card" style="margin-top:16px">
        <div class="m184-card__head">
          <mat-icon>list</mat-icon>
          <span class="m184-card__head-label">Relación de socios</span>
        </div>
        <div class="m184-card__body">
          <div class="m184-actions" style="margin-bottom:12px">
            <button mat-stroked-button class="m184-btn" (click)="openModal(modelSocio)">
              <mat-icon>add</mat-icon> Añadir
            </button>
          </div>
          <div class="m184-table-wrap">
            <table class="m184-table">
              <thead>
                <tr>
                  <th>Orden</th>
                  <th>Estado</th>
                  <th>Presentado el</th>
                  <th>N.I.F Miembro</th>
                  <th>N.I.F Repres. Fiscal</th>
                  <th>Apellidos y Nombre o Razón Social</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>
                <tr>
                  <td>orden</td>
                  <td>estado</td>
                  <td>presentado</td>
                  <td>nif_miembro</td>
                  <td>nif_fiscal</td>
                  <td>apellidos</td>
                  <td>
                    <div class="m184-row-actions">
                      <button mat-stroked-button class="m184-btn" (click)="openModal(modelSocio)">
                        <mat-icon>edit</mat-icon> Editar
                      </button>
                      <button mat-stroked-button class="m184-btn">
                        <mat-icon>delete</mat-icon> Eliminar
                      </button>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </mat-tab>
  </mat-tab-group>

  <app-tax-disclaimer-notice></app-tax-disclaimer-notice>
</div>

<ng-template #modelRenta>
  <div class="m184-modal">
    <div class="m184-fields">
      <div>
        <span class="m184-field-label">Clave</span>
        <app-select name="renClave" [(ngModel)]="data"
          [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
      </div>
      <div>
        <span class="m184-field-label">Subclave</span>
        <app-select name="renSubclave" [(ngModel)]="data"
          [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
      </div>
      <div>
        <span class="m184-field-label">Pais</span>
        <app-select name="renPais" [(ngModel)]="data"
          [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
      </div>

      <app-input inputType="text" placeholder="NIF de Persona o Entidad Cesionaria / NIF Institución de Inversión Colectiva" name="renNifCesionario" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Denominación o Razón Social del Cesionario / Denominación de la Institución de Inversión Colectiva" name="renRazonCesionario" [(ngModel)]="data"></app-input>
      <app-input inputType="date" placeholder="Fecha adquisición" name="renFechaAdquisicion" [(ngModel)]="data"></app-input>

      <div>
        <span class="m184-field-label">Tipo Actividad</span>
        <app-select name="renTipoActividad" [(ngModel)]="data"
          [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
      </div>
      <div>
        <span class="m184-field-label">Grupo o Epígrafe</span>
        <app-select name="renGrupoEpigrafe" [(ngModel)]="data"
          [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
      </div>
      <div>
        <span class="m184-field-label">Régimen determinación rendimientos</span>
        <app-select name="renRegimenRendimientos" [(ngModel)]="data"
          [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
      </div>

      <app-input inputType="text" placeholder="Importe Ingresos íntegros / Importe Rendimientos Devengados / Resultado Contable" name="renImporteIngresos" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Gastos / Exceso Rentas Negativas" name="renGastos" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Importe Renta atribuible / Rendimiento Neto Atribuible / Rendimiento Neto Atribuible Previo" name="renRentaAtribuible" [(ngModel)]="data"></app-input>

      <app-input inputType="text" placeholder="% Reducción" name="renPorcentajeReduccion" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Renta atribuible con derecho a reducción" name="renRentaConDerecho" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Ganancias/Pérdidas" name="renGananciasPerdidas" [(ngModel)]="data"></app-input>

      <app-input inputType="text" placeholder="Valor adquisición, suscripción o contable / Ajustes:Disminuciones" name="renValorAdquisicion" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Valor Liquidativo / Ajustes:Aumentos" name="renValorLiquidativo" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Base de la deducción / Importe" name="renBaseDeduccion" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Retenciones e ingresos a cuenta" name="renRetenciones" [(ngModel)]="data"></app-input>
      <div>
        <span class="m184-field-label">Situación inmueble</span>
        <app-select name="renSituacionInmueble" [(ngModel)]="data"
          [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
      </div>
      <app-input inputType="text" placeholder="Referencia catastral" name="renReferenciaCatastral" [(ngModel)]="data"></app-input>
    </div>

    <span class="m184-subhead" style="margin-top:16px">Detalles de gastos / Rendimientos de actividades económicas</span>
    <div class="m184-fields">
      <app-input inputType="text" placeholder="Gastos Personal" name="renGastosPersonal" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Consumos de explotación" name="renConsumosExplotacion" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Tributos Fiscalmente deducibles" name="renTributosDeducibles" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Arrendamientos y canones" name="renArrendamientosCanones" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Reperaciones y conservación" name="renReparacionesConservacion" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Servicios profesionales independientes" name="renServiciosProfesionales" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Suministros" name="renSuministros" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Gastos financieros" name="renGastosFinancieros" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Amortizaciones" name="renAmortizaciones" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Provisiones" name="renProvisiones" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Otros Gastos Fiscalmente Deducibles" name="renOtrosGastosDeducibles" [(ngModel)]="data"></app-input>
    </div>
    <div class="m184-check-row">
      <span style="margin:0">Criterio de cobros y gastos</span>
      <mat-checkbox name="renCriterioCobrosGastos" [(ngModel)]="data"></mat-checkbox>
    </div>

    <span class="m184-subhead" style="margin-top:16px">Detalles gastos / Rendimientos de capital inmobiliario</span>
    <div class="m184-fields">
      <app-input inputType="text" placeholder="Intereses y demás gastos de financiacion" name="renInteresesFinanciacion" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Conversación y reparación" name="renConservacionReparacion" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Intereses / Gastos de reparación y conservación pendientes" name="renInteresesPendientes" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Tributos y recargos" name="renTributosRecargos" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Saldos de dudoso cobro" name="renSaldosDudosoCobro" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Cantidades devengadas por terceros" name="renCantidadesTerceros" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Primas seguros" name="renPrimasSeguros" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Amortización del inmueble" name="renAmortizacionInmueble" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Amortización de bienes muebles" name="renAmortizacionBienesMuebles" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Otros gastos deduciles" name="renOtrosGastosDeducibles2" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Número de días de arrendamiento o cesión de uso y disfrute" name="renDiasArrendamiento" [(ngModel)]="data"></app-input>
    </div>

    <div class="m184-modal-actions">
      <button mat-stroked-button class="m184-btn" (click)="closeModal()">
        <mat-icon>add</mat-icon> Añadir
      </button>
      <button mat-stroked-button class="m184-btn" (click)="closeModal()">
        Cerrar
      </button>
    </div>
  </div>
</ng-template>

<ng-template #modelSocio>
  <div class="m184-modal">
    <div class="m184-fields">
      <app-input inputType="text" placeholder="NIF miembro" name="socNifMiembro" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="NIF Representante fiscal" name="socNifRepresentante" [(ngModel)]="data"></app-input>
      <div style="flex:2 1 320px">
        <app-input inputType="text" placeholder="Apellidos y nombre o Razón Social" name="socRazonSocial" [(ngModel)]="data"></app-input>
      </div>

      <div>
        <span class="m184-field-label">Tipo Partícipe</span>
        <app-select name="socTipoParticipe" [(ngModel)]="data"
          [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
      </div>
      <div>
        <span class="m184-field-label">Código Provincia</span>
        <app-select name="socCodigoProvincia" [(ngModel)]="data"
          [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
      </div>
      <div>
        <span class="m184-field-label">Clave País</span>
        <app-select name="socClavePais" [(ngModel)]="data"
          [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
      </div>
      <div class="m184-check-row" style="flex:1 1 260px">
        <span style="margin:0">A 31 de Diciembre sigue siendo miembro de la entidad</span>
        <mat-checkbox name="socMiembroA31Dic" [(ngModel)]="data"></mat-checkbox>
      </div>

      <app-input inputType="text" placeholder="Número de días del año en que ha sido miembro de la entidad" name="socDiasMiembro" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Porcentaje de Participación" name="socPorcentajeParticipacion" [(ngModel)]="data"></app-input>
      <app-input inputType="text" placeholder="Domicilio Fiscal del Miembro de la Entidad" name="socDomicilioFiscal" [(ngModel)]="data"></app-input>
    </div>

    <div class="m184-card" style="margin-top:16px">
      <div class="m184-card__head">
        <mat-icon>list</mat-icon>
        <span class="m184-card__head-label">Relación de claves de socio</span>
      </div>
      <div class="m184-card__body">
        <div class="m184-actions" style="margin-bottom:12px">
          <button mat-stroked-button class="m184-btn" (click)="openModal(modelClaveSocio)">
            <mat-icon>add</mat-icon> Añadir
          </button>
        </div>
        <div class="m184-table-wrap">
          <table class="m184-table">
            <thead>
              <tr>
                <th>Orden</th>
                <th>Estado</th>
                <th>Presentado el</th>
                <th>Clave</th>
                <th>Subclave</th>
                <th>Importe</th>
                <th>Reducción</th>
                <th>Naturaleza</th>
                <th>Situación</th>
                <th>Referencia</th>
                <th>Clave declarado</th>
                <th>Porcentaje</th>
                <th>Dias arren</th>
                <th></th>
              </tr>
            </thead>
            <tbody>
              <tr>
                <td>orden</td>
                <td>estado</td>
                <td>presentado</td>
                <td>clave</td>
                <td>sub</td>
                <td>importe</td>
                <td>reduc</td>
                <td>natu</td>
                <td>situc</td>
                <td>ref</td>
                <td>clave_declardo</td>
                <td>porcen</td>
                <td>dias</td>
                <td>
                  <div class="m184-row-actions">
                    <button mat-stroked-button class="m184-btn" (click)="openModal(modelClaveSocio)">
                      <mat-icon>edit</mat-icon> Editar
                    </button>
                    <button mat-stroked-button class="m184-btn">
                      <mat-icon>delete</mat-icon> Eliminar
                    </button>
                  </div>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>

    <div class="m184-modal-actions">
      <button mat-stroked-button class="m184-btn" (click)="closeModal()">
        <mat-icon>add</mat-icon> Añadir
      </button>
      <button mat-stroked-button class="m184-btn" (click)="closeModal()">
        Cerrar
      </button>
    </div>
  </div>

  <ng-template #modelClaveSocio>
    <div class="m184-modal">
      <div class="m184-fields">
        <app-input inputType="text" placeholder="NIF" name="csNif" [(ngModel)]="data"></app-input>
        <app-input inputType="text" placeholder="NIF Representate" name="csNifRepresentante" [(ngModel)]="data"></app-input>
        <app-input inputType="text" placeholder="Apellidos y Nombre o Razón Social" name="csRazonSocial" [(ngModel)]="data"></app-input>

        <div>
          <span class="m184-field-label">Clave</span>
          <app-select name="csClave" [(ngModel)]="data"
            [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
        </div>
        <div>
          <span class="m184-field-label">Subclave</span>
          <app-select name="csSubclave" [(ngModel)]="data"
            [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
        </div>
        <app-input inputType="text" placeholder="Importe(Rendimiento/Retención/Deducción)" name="csImporte" [(ngModel)]="data"></app-input>

        <app-input inputType="text" placeholder="Reducción" name="csReduccion" [(ngModel)]="data"></app-input>
        <app-input inputType="text" placeholder="Provisiones deducibles y gastos de difícil justificación" name="csProvisionesDeducibles" [(ngModel)]="data"></app-input>

        <div>
          <span class="m184-field-label">Naturaleza del inmuele</span>
          <app-select name="csNaturalezaInmueble" [(ngModel)]="data"
            [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
        </div>
        <div>
          <span class="m184-field-label">Situación inmueble</span>
          <app-select name="csSituacionInmueble" [(ngModel)]="data"
            [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
        </div>
        <app-input inputType="text" placeholder="Referencia catastral" name="csReferenciaCatastral" [(ngModel)]="data"></app-input>
        <div>
          <span class="m184-field-label">Clave declarado</span>
          <app-select name="csClaveDeclarado" [(ngModel)]="data"
            [config]="{ options: [{ label: 'Calle', value: 'Calle' }, { label: 'No', value: '2' }] }"></app-select>
        </div>

        <app-input inputType="text" placeholder="Porcentaje de titularidad del inmueble" name="csPorcentajeTitularidad" [(ngModel)]="data"></app-input>
        <app-input inputType="text" placeholder="Número de días de arrendamiento o cesión de uso y disfrute del inmueble" name="csDiasArrendamiento" [(ngModel)]="data"></app-input>

        <div style="flex:1 1 100%">
          <app-input inputType="text" placeholder="Rendimiento Neto Previo de actividades económicas en estimación objetiva (excepto agrícolas, ganaderas y forestales)" name="csRendimientoNetoPrevio" [(ngModel)]="data"></app-input>
        </div>
        <app-input inputType="text" placeholder="Rendimiento Neto Minorado de actividades agrícolas, ganaderas y forestales en estimación objetiva" name="csRendimientoNetoMinorado" [(ngModel)]="data"></app-input>
      </div>

      <div class="m184-modal-actions">
        <button mat-stroked-button class="m184-btn" (click)="closeModal()">
          <mat-icon>add</mat-icon> Añadir
        </button>
        <button mat-stroked-button class="m184-btn" (click)="closeModal()">
          Cerrar
        </button>
      </div>
    </div>
  </ng-template>
</ng-template>
